import React, { Fragment, useState, useEffect, useCallback } from 'react';
import MainLayout from '../components/layouts/MainLayout';
import StaffDetail from '../components/views/staffs/StaffDetail';
import Spin from '../components/Spin';
import countryInfo from '../assets/countries.json';
import * as api from '../api';

const StaffDetailContainer = ({
  history,
  match,
}) => {
  const staffId = match.params.id;
  const countryInfoList = Object.values(countryInfo);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ countryNumber, setCountryNumber ] = useState('82');
  const [ staffUpdateItem, setStaffUpdateItem ] = useState({
    name: '',
    role: '',
    phoneNumber: '',
    status: '',
    createdAt: '',
    updatedAt: '',
  });
  const [ staffkeyListItems, setStaffkeyListItems ] = useState([]);

  const moveToListPage = () => {
    history.push('/staff');
  };

  const selectStaff = useCallback(async () => {
    try {
      const res = await api.selectStaff({staffId});
      setStaffUpdateItem({
        name: res.data.name,
        role: res.data.role,
        phoneNumber: res.data.phone_number.replace(/([0-9]*)(\d{10})/, '0$2'),
        status: res.data.status,
        createdAt: res.data.created_at,
        updatedAt: res.data.updated_at,
      });
      setCountryNumber(res.data.phone_number.replace(/([0-9]*)(\d{10})/, '$1'));
    } catch (error) {
      throw error;
    }
  }, [staffId]);

  const listStaffkey = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await api.listStaffkey({staffId});
      setStaffkeyListItems(res.data.items);
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [staffId]);

  const updateStaff = async () => {
    try {
      setIsLoading(true);
      await api.updateStaff({staffId, ...staffUpdateItem});
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    try {
      if (staffId) {
        selectStaff();
        listStaffkey();
      }
    } catch (error) {
      throw error;
    }
  }, [staffId, selectStaff, listStaffkey]);

  return (
    <Fragment>
      <Spin isSpin={isLoading}/>
      <MainLayout
        history={history}
        refresh={() => moveToListPage()}
        ContentBody={(
          <StaffDetail
            staffId={staffId}
            countryInfoList={countryInfoList}
            countryNumber={countryNumber}
            staffUpdateItem={staffUpdateItem}
            staffkeyListItems={staffkeyListItems}
            setStaffUpdateItem={setStaffUpdateItem}
            selectStaffApi={selectStaff}
            updateStaffApi={updateStaff}
            listStaffkeyApi={listStaffkey}
            moveToListPage={moveToListPage}
            history={history}
          />
        )}
      />
    </Fragment>
  );
}

export default StaffDetailContainer;